export default __webpack_public_path__ + "app-install-error.5d9d1e0451a6de90a146b3e75ba98f10.svg";